// extracted by mini-css-extract-plugin
export default {"comment_list":"Comment_comment_list__5FzSR"};